var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendemail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.167 17.7084H5.83366C2.79199 17.7084 1.04199 15.9584 1.04199 12.9167V7.08341C1.04199 4.04175 2.79199 2.29175 5.83366 2.29175H14.167C17.2087 2.29175 18.9587 4.04175 18.9587 7.08341V12.9167C18.9587 15.9584 17.2087 17.7084 14.167 17.7084ZM5.83366 3.54175C3.45033 3.54175 2.29199 4.70008 2.29199 7.08341V12.9167C2.29199 15.3001 3.45033 16.4584 5.83366 16.4584H14.167C16.5503 16.4584 17.7087 15.3001 17.7087 12.9167V7.08341C17.7087 4.70008 16.5503 3.54175 14.167 3.54175H5.83366Z",
    fill: "#5A6ACF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 10.725C9.29998 10.725 8.59165 10.5083 8.04998 10.0666L5.44164 7.98331C5.17498 7.76664 5.12498 7.37497 5.34165 7.10831C5.55831 6.84164 5.94998 6.79164 6.21665 7.00831L8.82497 9.09164C9.45831 9.59998 10.5333 9.59998 11.1666 9.09164L13.775 7.00831C14.0416 6.79164 14.4416 6.83331 14.65 7.10831C14.8666 7.37497 14.825 7.77498 14.55 7.98331L11.9416 10.0666C11.4083 10.5083 10.7 10.725 9.99998 10.725Z",
    fill: "#5A6ACF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendemail);
export default __webpack_public_path__ + "static/media/sendemail.93ae7345973edf1609eaa04f363bf6c1.svg";
export { ForwardRef as ReactComponent };